import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const create = async function(data) {
    const {newGroup} = data;   
    const group = {
        newGroup,
    };
    return apiService.post('group', group);
}

const getGroups = function () {
    return apiService.get('group');
    }

export default {
    create,
    getGroups,
}